import React from "react";
import { DownArrowIcon } from "../../../../Icons";
// import { useSelector } from "react-redux";

const ActiveAccount = ({ activeAccount }) => {
  // const { name } = useSelector((state) => state.ownCompany.company);
  return (
    <>
      {activeAccount && (
        <div className="primary-card-active-account">
          <div className="flex items-center pr-12">
            <img
              src={activeAccount?.logo}
              alt="flag"
              className="w-10 h-10 rounded-full"
            />
            <div className="px-2">
              <p>
                {activeAccount.account_number}
              </p>
              <p>
                {activeAccount.currency_code} · {activeAccount.title}
              </p>
            </div>
          </div>
          <DownArrowIcon className="h-5 w-5 pr-5" />
        </div>
      )}
    </>
  );
};

export default ActiveAccount;
